module.exports = __webpack_public_path__ + "static/img/novalloy-interpretive-sign.3a904be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/graphic-panels/novalloy-interpretive-sign.jpg
// module id = 666
// module chunks = 0